/* eslint-disable */
// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

// APP CONFIG
export const $themeConfig = {
    app: {
        appName: 'MILAN', // Will update name in navigation menu (Branding)
        appVer: 10200,
        // eslint-disable-next-line global-require
        appLogoImage: require('@/assets/images/logo/logo.svg'), // Will update logo in navigation menu (Branding),
        appTextImage: require('@/assets/images/logo/logo-text-light.svg'), // Will update logo in navigation menu (Branding)
        //apiUrl: 'http://192.168.30.68:3994',
        //wsUrl: 'ws://192.168.30.68:3994/webtool/?auth=7303cdd4eb9991cad8d7bd70240b3b20.c14547c17e3db969033e8e4a5fa16f27.8eddb3797212cedc470043e1d3686176',
       
        apiUrl: 'https://ws.milan-tool.disscovery.org',
        wsUrl: 'wss://ws.milan-tool.disscovery.org/webtool/?auth=7303cdd4eb9991cad8d7bd70240b3b20.c14547c17e3db969033e8e4a5fa16f27.8eddb3797212cedc470043e1d3686176',
        
        apiPort: '',
        apiAuth: 'ba99835ada44899bad5366d6e2497e8f',
    },
    layout: {
        isRTL: false,
        skin: 'semi-dark', // light, dark, bordered, semi-dark
        routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
        type: 'vertical', // vertical, horizontal
        contentWidth: 'full', // full, boxed
        menu: {
            hidden: false,
            isCollapsed: true,
        },
        navbar: {
            // ? For horizontal menu, navbar type will work for navMenu type
            type: 'sticky', // static , sticky , floating, hidden
            backgroundColor: '', // BS color options [primary, success, etc]
        },
        footer: {
            type: 'static', // static, sticky, hidden
        },
        customizer: false,
        enableScrollToTop: true,
    },
}